import { render } from "./cadence-change-warning.vue?vue&type=template&id=c81fd548&lang=pug"
import script from "./cadence-change-warning.vue?vue&type=script&lang=js"
export * from "./cadence-change-warning.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__